import React, { useState } from 'react';
import { View, Text, Modal, TouchableOpacity } from 'react-native';
import {
  useNavigation,
  useRoute,
  useFocusEffect,
} from '@react-navigation/native';
import { useSelector, useDispatch } from 'react-redux';
import { Payment } from '../../../screens/main/donate/payment';
import { ModalTemplate } from '@components/templates';
import { Button } from '@components/atoms';
import { styles } from './styles';
import Close from '@images/icons/close-gray.svg';
import StarStruck from '@images/icons/star-struck.svg';
import {
  selectMustShowDonate,
  selectMustHideDonateForever,
} from '@selectors/donate';
import { goPay } from '../../../lib/goPay';
import * as actions from '@actions';

export const DonateCTA = ({ immediatelyAfterTheCountdown }) => {
  const navigation = useNavigation();
  const route = useRoute();
  const dispatch = useDispatch();
  // console.log('name:', name);
  const mustShowDonate = useSelector(selectMustShowDonate);
  const mustHideDonateForever = useSelector(selectMustHideDonateForever);

  const [visible, setVisible] = useState(false);

  const close = () => {
    setVisible(false);
    dispatch(actions.hideDonate());
  };

  const onClickDonate = () => {
    close();
    goPay(navigation, route);
  };

  React.useEffect(() => {
    const unsubscribe = navigation.addListener('focus', () => {
      if (mustShowDonate) {
        setVisible(true);
      }
    });
    //console.warn('showDonate!', mustShowDonate, mustHideDonateForever);
    return unsubscribe;
  }, [navigation, mustShowDonate, mustHideDonateForever]);

  useFocusEffect(
    React.useCallback(() => {
      if (immediatelyAfterTheCountdown && mustShowDonate) {
        setVisible(true);
      }
      //console.warn('showDonate!', mustShowDonate);
    }, [immediatelyAfterTheCountdown, mustShowDonate]),
  );

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={visible}
      statusBarTranslucent
      onRequestClose={close}
    >
      <ModalTemplate rootStyles={styles.backstage}>
        <View style={styles.modalContainer}>
          <TouchableOpacity onPress={close} style={styles.closeIcon}>
            <Close />
          </TouchableOpacity>
          <StarStruck />
          <Text style={styles.text}>
            Купить полный доступ{'\n'}за{' '}
            <Text style={styles.amount}>300₽ в месяц</Text>
          </Text>
          <Text style={styles.detail}>
            Вы покупаете полный доступ ко всем тестам с полным функционалом: все
            области тестирования, поиск по вопросам, тест по избранному, режим
            тестирования и экзамена
          </Text>

          <Payment
            onPressPayment={onClickDonate}
            style={styles.btn}
            //isFetching={isFetching}
            //disabled={isFetching}
          />
        </View>
      </ModalTemplate>
    </Modal>
  );
};
